import { render, staticRenderFns } from "./ConnectItem.vue?vue&type=template&id=567e19c8&scoped=true&"
import script from "./ConnectItem.vue?vue&type=script&lang=js&"
export * from "./ConnectItem.vue?vue&type=script&lang=js&"
import style0 from "./ConnectItem.vue?vue&type=style&index=0&id=567e19c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567e19c8",
  null
  
)

export default component.exports